export default "__VITE_ASSET__CBKn7CYD__"